// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Dent } = initSchema(schema);

export {
  Dent
};